// extracted by mini-css-extract-plugin
export default {"row":"classes_row__wzCG4","left":"classes_left__OERQQ","nftImage":"classes_nftImage__u8wH6","color":"classes_color__Hjg4B"};